<div #componentContainer *ngIf="!documentIsComplete"></div>

<div *ngIf="documentIsComplete">
    <div class="doc-upload-actions">
        <button mat-button class="secondary" (click)="returnToJacket()">Back to Documents</button>
    </div>
    <div class="upload-card" *ngIf="documentIsComplete">
        <mat-card>
            <div class="upload-card-body">
                <h2>Driver's License</h2>
                <p>This document has already been uploaded.</p>
            </div>
        </mat-card>
    </div>
</div>

<div [ngClass]="{ hidden: !showPreviewUpload }">
    <div class="upload-actions">
        <button mat-button type="button" class="primary" (click)="uploadLicense(lastImageData, true)">{{
            uploadButtonDisplayName
            }}</button>
        <button class="secondary" mat-button type="button" (click)="cancelUpload()">Restart</button>
    </div>
    <div class="final-upload-preview">
        <canvas #frontUploadPreview class="hidden"> </canvas>
        <canvas #backUploadPreview class="hidden"> </canvas>
    </div>
</div>

<div style="margin: 20px 15px" *ngIf="developmentModeAvailable && !isLoading">
    <div style="display: flex; align-items: center; flex-wrap: wrap; justify-content: space-between">
        <mat-slide-toggle [checked]="developmentModeOn" (change)="onDevelopmentModeToggle()">
            Turn {{ !developmentModeOn ? 'On' : 'Off' }} Development Mode
        </mat-slide-toggle>
        <button *ngIf="workflowComponents?.length > 0 && developmentModeOn"
            (click)="resetDevelopmentModeWorkflow()">Reset Components</button>
    </div>

    <div *ngIf="workflowComponents?.length === 0 && developmentModeOn">
        <mat-selection-list #selectedDevModeComps>
            <mat-list-option *ngFor="let component of developmentModeComponents" [value]="component">{{ component.name
                }}</mat-list-option>
        </mat-selection-list>
        <button (click)="startDevelopmentModeWorkflow(selectedDevModeComps)"
            *ngIf="selectedDevModeComps?.selectedOptions?.selected?.length > 0"
            style="margin-top: 20px; font-size: 16px">
            Run Workflow
        </button>
    </div>
</div>

<ddj-spinner *ngIf="isLoading && !isProcessingDl" [phrase]="loadingMessage"></ddj-spinner>
<ddj-license-spinner *ngIf="isProcessingDl && !isLoading"
    [phraseOverrides]="loadingMessageOverrides"></ddj-license-spinner>